/*
 * 员工相关接口
 */
import request from '../request'
import { LoginCheck } from '../model'

enum Api {
  LOGIN_API = 'staff/login',
  CHANGE_PWD = 'staff/updatePwd',
  LOGOUT_API = 'staff/loginOut',

  FORGET_PWD = 'staff/forgetPassword'
}

export default class AjaxAuthService {
  /**
   * 登录
   * @param data
   * @returns
   */
  static login(data: any): Promise<any> {
    return request.post(Api.LOGIN_API, data)
  }
  /**
   * 发送验证码
   * @param data
   * @returns
   */
  static sendEmail(data: any): Promise<any> {
    return request.post('/captcha/send', data)
  }
  static sendSmsByPhone(data: any): Promise<any> {
    return request.post('/sms-record/sendSmsCaptcha', data)
  }
  /**
   * 忘记密码
   * @param data
   * @returns
   */
  static forgetPwd(data: any): Promise<any> {
    return request.post('/staff/forgetPwd', data)
  }
  /**
   * 设备验证
   * @param data
   * @returns
   */
  static checkNewDevice(data: LoginCheck | undefined): Promise<any> {
    return request.post('/staff/checkNewDevice', data)
  }
  /**
   * 退出登录
   * @returns
   */
  static logOut(): Promise<any> {
    return request.post(Api.LOGOUT_API)
  }
  /**
   * 修改密码
   * @returns
   */
  static changePwd(data: any): Promise<any> {
    return request.post(Api.CHANGE_PWD, data)
  }

  /**
   * 设置新密码
   * @returns
   */
  static setPwd(data: any): Promise<any> {
    return request.post(Api.FORGET_PWD, data)
  }
}
